
import { history } from "@src/history";
export default (e, path) => {
    if(e)
      e.preventDefault();
     history.push(path)
}